const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
        title: 'Type',
        dataIndex: 'type',
        sorter: (a, b) => a?.type?.localeCompare(b?.type),
    },
    {
        title: 'Amount',
        dataIndex: 'amount',
        sorter: (a, b) => a?.amount - b?.amount,
    },
    {
        title: 'Status',
        dataIndex: 'status',
        
    },
    {
        title: 'Requested Date',
        dataIndex: 'requestDate',
        sorter: (a, b) => ((new Date(a.requestDate)) - (new Date(b.requestDate))),
    },
];

export default columns;